var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1667 6.79492C57.1161 6.79492 71.6667 21.3457 71.6667 39.2949C71.6667 57.2443 57.1161 71.7949 39.1667 71.7949C21.2175 71.7949 6.66675 57.2443 6.66675 39.2949C6.66675 21.3457 21.2175 6.79492 39.1667 6.79492ZM39.1667 11.7949C23.9789 11.7949 11.6667 24.1071 11.6667 39.2949C11.6667 54.4826 23.9789 66.7949 39.1667 66.7949C54.3544 66.7949 66.6667 54.4826 66.6667 39.2949C66.6667 24.1071 54.3544 11.7949 39.1667 11.7949ZM39.1667 20.1283C40.4324 20.1283 41.4784 21.0688 41.6441 22.289L41.6667 22.6283V38.2583L50.9344 47.5273C51.8221 48.4146 51.9027 49.8036 51.1764 50.7823L50.9344 51.0626C50.0471 51.9503 48.6581 52.0309 47.6794 51.3046L47.3991 51.0626L37.399 41.0626C37.0239 40.6876 36.7803 40.2056 36.6979 39.6884L36.6667 39.2949V22.6283C36.6667 21.2476 37.786 20.1283 39.1667 20.1283Z",
    fill: "#F7B916"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.3c800ddc5f5c56a5d5ecd2ae650c7347.svg";
export { ForwardRef as ReactComponent };